<template>

   <!-- <ion-content class="ion-padding"> -->
    <div >
        <ion-button  class="openMenu circular" @click="openNav">
          <!-- <ion-icon @click="openNav" ios="ios-menu" md="md-menu"></ion-icon> -->
          <ion-icon  @click="openNav" name="arrow-round-forward"></ion-icon>
       </ion-button >
       <div id="mySidenav" class="sidenav">
          
            <a href="javascript:void(0)" class="closebtn " @click="closeNav">
                <!-- <ion-icon  ios="ios-arrow-round-back" md="md-arrow-round-back"></ion-icon> -->
                 <!-- <ion-icon @click="openNav" ios="ios-menu" md="md-menu"></ion-icon> -->
                 <ion-icon @click="openNav" name="arrow-round-back" ></ion-icon>
            </a>
            
                <slot slot="title"></slot> 
                <slot slot="body"></slot>          
                
          
        </div>
    </div>
   <!-- </ion-content> -->
  

</template>
<script>

import {DeviceEventBus} from '../DeviceEventBus.js'
export default {
    
    mounted(){
         DeviceEventBus.$on('orientation',this.handleOr) 
    },
    data(){
       return {
            size:null,
            navBarWidth:null,
            isNavOn:false,
            isOpen: false,
        }
    },
    components:{
        
       
    },
    methods:{
        handleOr (e){
            // console.log('handler SideBar  resizing',e)
            this.size= e.size;
            if(this.isNavOn && this.size){
                document.getElementById("mySidenav").style.width =`${this.size.width/2}px` 
            }
        },
        closeNav(){
             document.getElementById("mySidenav").style.width = "0";
             this.isNavOn = false
        },
        openNav() {
             
            if(this.size)
            {
                console.log('openNav ',`${this.size.width/2}px`)
                document.getElementById("mySidenav").style.width =`${this.size.width/2}px`  
                  
            }else{
               
                document.getElementById("mySidenav").style.width = "450px";
            }
            this.isNavOn = true
        },
        
    }
}
</script>


<style scoped>
  
 
    .sidenav {
        height: 100%;
        width: 0;
        position: fixed;
        z-index: 1;
        top: 0.001em;
        left: 0;
        background-color: rgba(107, 121, 130, 0.945);
        /* background-color: rgb(6, 179, 247); */
        overflow-x: hidden;
        transition: 0.5s;
        padding-top: 30px;
    }

    .sidenav a {
        padding: 8px 8px 8px 32px;
        text-decoration: none;
        font-size: 25px;
        color: #818181;
        display: block;
        transition: 0.3s;
    }

    .sidenav a:hover {
        color: #f1f1f1;
    }

    .sidenav .closebtn {
        position: absolute;
        top: 0;
        right: 0px;
        font-size: 25px;
        margin-left: 50px;
        color: aqua;
    }

    @media screen and (max-height: 450px) {
    .sidenav {padding-top: 15px;}
    .sidenav a {font-size: 18px;}
    }
    .circular{--width: 40%;--height: 40%;--border-radius: 50%;
          --vertical-align: middle;--padding-start: 10px;
          --padding-end: 10px;
          --border-style: inset;
          --background: transparent;
          --color: #222;
  
           
    }

</style>

